module.exports = __webpack_public_path__ + "static/messenger-secret-21928557b61902eb2cf2e4611aeb3fe7.png";